import { HttpHeaders } from "@angular/common/http";
import { AppConfig, AppEvent } from "../model/appConfig";
import { AuthModel } from "../model/authModel";
import { environment } from "../environments/environment";
import {FamilyEntity, FamilyEvaluationAppointment, FamilyPage, ListItem, Team} from "../model/familyAndTeam";
import { Appointment, BackEndCalendarEvent, SchedulableItem, SchedulableItemPage } from "../model/calendar";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { ServiceLevel } from "../model/services";

export class State {

  public static LOAD_COUNT = 4;

  public static jwt: string | undefined;
  public static config: AppConfig;
  public static loggedOut: boolean = true;
  public static justRegistered: boolean | undefined;
  public static user: AuthModel | undefined;
  static language: string = 'en';
  static shouldLogout : boolean = false;
  static isLoaded : boolean = true;
  static families : FamilyPage;
  static currentFamily : FamilyEntity;
  static schedulableItems : SchedulableItemPage;
  static calendarEvents : BackEndCalendarEvent[];
  static familyAppointments : Appointment[];
  static familyList? : ListItem[];
  static familyEvaluationAppointments : FamilyEvaluationAppointment[];
  static teams : Team[];
  static events$ : BehaviorSubject<AppEvent> = new BehaviorSubject<AppEvent>({discriminator: ''})
  static serviceLevels: ServiceLevel[];
  static editedAppointment : Appointment | undefined;
  static dashBoardEnabled : boolean = false;


  static setJwt(jwt: string | undefined) {
    if (!jwt)
      return;
    const regex = /"/ig;
    State.jwt = jwt.replace(regex, '');;
  }


  static logout() {

    State.jwt = undefined;
    State.loggedOut  = true;
    State.justRegistered  = undefined;
    State.user  = undefined;

  }

  static gotoSamlLogin() {
      if (typeof window !== 'undefined') {
        const timestamp = new Date().getTime();
        const randomNum = Math.floor(Math.random() * 1000000);
        const guid = `${timestamp}-${randomNum}`
        console.log('guid', guid);
        if (environment.appConfig.environment == 'DEV') {
          window.open ('http://localhost:8079/?app=' + environment.samlApp, '_self')
        } else {
          window.open ('https://auth-gwy.huddyhealth.com/?app=' + environment.samlApp, '_self')
        };
      }
    }

  static getAuthHeaders() : HttpHeaders {
    console.log('getAuthHeaders', State.user);
    if (State.user && State.jwt) {
      const trustedUserHeader : string | undefined = State.user.trustedUser;
      const headers: {[name: string]: string | string[]; } = {};
      if (trustedUserHeader) {
      headers['Trusted-User'] = [trustedUserHeader];
      }
      headers['Authorization'] = State.jwt;
      return new HttpHeaders(headers);
    }
    return new HttpHeaders();
  }

  static setState(appEvent : AppEvent) {
    console.log('setState', appEvent.discriminator, appEvent);
    if (appEvent.discriminator == 'families' && appEvent.families) {
      State.families = appEvent.families;
    } else if (appEvent.discriminator == 'currentFamily' && appEvent.currentFamily) {
      State.currentFamily = appEvent.currentFamily;
    }else if (appEvent.discriminator == 'schedulableItems' && appEvent.schedulableItems) {
      State.schedulableItems = appEvent.schedulableItems;
    }else if (appEvent.discriminator == 'calendarEvents' && appEvent.calendarEvents) {
      State.calendarEvents = appEvent.calendarEvents;
    }else if (appEvent.discriminator == 'familyAppointments' && appEvent.familyAppointments) {
      State.familyAppointments = appEvent.familyAppointments;
    }else if (appEvent.discriminator == 'teams' && appEvent.teams) {
      State.teams = appEvent.teams;
    } else if (appEvent.discriminator == 'serviceLevels' && appEvent.serviceLevels) {
      State.serviceLevels = appEvent.serviceLevels;
    } else if (appEvent.discriminator == 'familyEvaluationAppointments' && appEvent.familyEvaluationAppointments) {
      State.familyEvaluationAppointments = appEvent.familyEvaluationAppointments;
    } else if (appEvent.discriminator == 'familyList') {
      State.familyList = appEvent.familyList;
    }
    State.events$.next(appEvent);
  }
}

